import { Vector3 } from "three";

import { Actor } from "../../../../world/actor/actor";
import { Context } from "../../../../context";
import { ControllerStrategy } from "../../strategy";

import { LookAtControllerStrategy } from "./simple";

export class LookAtBallControllerStrategy extends LookAtControllerStrategy {
  offset: Vector3 = new Vector3(0, 1, 0);
  pointedAtBall = false;

  maxAge = 100;

  init(context: Context): ControllerStrategy {
    if (!this.registered) {
      console.error("no controller registered");
      return this;
    }

    super.init(context);

    const ball = context.world?.ball;

    this.registered.state.tracked =
      ball?.age != undefined && ball.age < this.maxAge ? ball.ball : this.mound;

    return this;
  }

  update(deltaS: number, gameTimeDelta: number, frameNum?: number) {
    const toUpdate = frameNum == undefined || this.lastFrameNum != frameNum;

    super.update(deltaS, gameTimeDelta, frameNum);

    if (!toUpdate || !this.registered) return;

    const ball = this.registered.contextRef.world?.ball;
    const context = this.registered.contextRef;

    if (ball && ball.age != undefined && ball.age < this.maxAge) {
      if (!this.pointedAtBall) {
        this.registered.state.tracked = ball.ball;
        this.pointedAtBall = true;
      }
    } else if (this.pointedAtBall) {
      const actor = super.findNewActor(
        context,
        this.registered.state.positionId
      );
      if (!actor) {
        console.error("pointing at mound!");
      }
      this.registered.state.tracked = actor ? actor.centroid : this.mound;
      this.pointedAtBall = false;
    }

    if (frameNum != undefined) this.lastFrameNum = frameNum;
  }

  protected findNewActor(
    _context: Context,
    _newPosId: number
  ): Actor | undefined {
    return undefined;
  }
}
